import { app } from '../../../../app';

app.component('confirmRemoveRecovery', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-remove-recovery.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/confirm-remove-recovery/confirm-remove-recovery.component.js